var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookFg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 616,
    viewBox: "0 0 567 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M108.57 417.13C108.57 417.13 130.72 432.5 124.09 457.13C116.92 483.75 98.61 508.73 87.52 514.32C87.52 514.32 94.74 583.09 55.52 575.96C14.18 568.44 55.52 494.5 55.52 494.5L108.57 417.13Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81 558.49C1.81 558.49 -15.5 449.41 60.28 429.66C60.28 429.66 81.01 370.05 94.39 383.55C107.77 397.05 121.6 415.94 98.45 455.55C75.3 495.16 59.2 501.67 59.2 501.67C59.2 501.67 81.81 541.36 55.2 578.19L1.81 558.49Z",
    fill: "#6EB5B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.32 398.33L99.54 398.62C99.6256 398.741 99.6716 398.886 99.6716 399.035C99.6716 399.184 99.6256 399.329 99.54 399.45L95.94 405L94.17 403L97.59 398.34L99.32 398.33Z",
    fill: "#417272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2 414.58C65.37 417.16 64.52 419.72 63.65 422.28L61 429.94L60.88 430.26L60.47 430.4C52.2384 433.288 44.5136 437.456 37.58 442.75C30.631 447.983 24.5062 454.23 19.41 461.28C16.8804 464.814 14.6047 468.524 12.6 472.38C10.5972 476.256 8.86314 480.266 7.41 484.38C4.52764 492.692 2.51684 501.282 1.41 510.01C1.51825 501.097 2.86446 492.242 5.41 483.7C6.04 481.56 6.80001 479.45 7.58001 477.35C8.36001 475.25 9.28 473.21 10.26 471.19C12.1693 467.134 14.4243 463.249 17 459.58C19.5774 455.889 22.4789 452.435 25.67 449.26C28.8527 446.055 32.3092 443.134 36 440.53C39.6431 437.908 43.5039 435.603 47.54 433.64C51.5601 431.628 55.7798 430.043 60.13 428.91L59.6 429.37L62.83 422C63.9433 419.507 65.0667 417.033 66.2 414.58Z",
    fill: "#514F4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.28 410.28L90.6 426.49C90.6 426.49 106.05 409.13 102.12 401.92C101.56 400.92 96.68 406.08 95.94 405.01C95.37 404.18 100.11 398.73 99.47 397.9C95 392.19 88 385.3 85.59 386C82.38 386.83 72.28 410.28 72.28 410.28Z",
    fill: "#D7D5B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6 426.49C90.6 426.49 85.08 411.29 72.28 410.28L90.6 426.49Z",
    fill: "#E7E4C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.26 433.38C66.5351 434.115 67.758 434.937 68.92 435.84C70.1 436.72 71.21 437.66 72.32 438.61C73.43 439.56 74.48 440.61 75.49 441.61C76.5326 442.655 77.5015 443.771 78.39 444.95C77.1132 444.213 75.8871 443.391 74.72 442.49C73.55 441.61 72.43 440.67 71.33 439.72C70.23 438.77 69.17 437.72 68.15 436.72C67.1107 435.675 66.145 434.559 65.26 433.38Z",
    fill: "#514F4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9 440.37C66.3981 440.438 66.8795 440.598 67.32 440.84C68.1445 441.278 68.8537 441.906 69.39 442.67C69.6707 443.074 69.8772 443.524 70 444C69.4987 443.932 69.014 443.772 68.57 443.53C68.1611 443.311 67.7787 443.046 67.43 442.74C67.0846 442.444 66.7758 442.109 66.51 441.74C66.2269 441.323 66.0203 440.859 65.9 440.37Z",
    fill: "#514F4C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.54 432.5C72.1518 432.707 72.731 433 73.26 433.37C73.7734 433.709 74.2524 434.098 74.69 434.53C75.1288 434.959 75.5271 435.428 75.88 435.93C76.2677 436.446 76.5715 437.019 76.78 437.63C76.1703 437.423 75.5917 437.133 75.06 436.77C74.55 436.427 74.0744 436.035 73.64 435.6C73.198 435.171 72.7964 434.702 72.44 434.2C72.058 433.681 71.7547 433.108 71.54 432.5Z",
    fill: "#514F4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.14 477.13C16.6011 478.188 17.1744 479.194 17.85 480.13C18.4965 481.052 19.1943 481.936 19.94 482.78C21.4406 484.452 23.0835 485.991 24.85 487.38C26.57 488.83 28.47 490.07 30.34 491.38C31.34 491.98 32.27 492.61 33.23 493.24C34.19 493.87 35.23 494.45 36.16 495.14C35.03 494.86 33.91 494.49 32.8 494.14C31.69 493.79 30.63 493.24 29.56 492.74C28.49 492.24 27.48 491.64 26.48 491.01C25.4818 490.37 24.5172 489.679 23.59 488.94C21.722 487.454 20.0784 485.706 18.71 483.75C18.39 483.24 18.06 482.75 17.77 482.22C17.48 481.69 17.21 481.17 17 480.61C16.5085 479.51 16.2173 478.332 16.14 477.13Z",
    fill: "#514F4C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.25 391.94L78.88 416.12L80.39 417.45L96.37 394.21L94.25 391.94Z",
    fill: "#FBF8D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.23 389.09L76.37 413.91L76.84 414.33L91.84 389.63L91.23 389.09Z",
    fill: "#FBF8D3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M507.46 614.68L503.58 0.22998L445.28 1.52998L449.12 615.04L507.46 614.68Z",
    fill: "url(#paint0_linear_2_3432)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M504 1.13998L507.87 615.59L566.18 614.3L562.33 0.789978L504 1.13998Z",
    fill: "url(#paint1_linear_2_3432)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_3432",
    x1: 456.01,
    y1: 307.63,
    x2: 518.18,
    y2: 307.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_3432",
    x1: 555.45,
    y1: 308.19,
    x2: 493.27,
    y2: 308.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookFg);
export default __webpack_public_path__ + "static/media/book-fg.5a3e7ae13853de1d6e6bcdd68f1627b5.svg";
export { ForwardRef as ReactComponent };